var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "button-box clearflex" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary", icon: "el-icon-plus" },
              on: { click: _vm.addUser },
            },
            [_vm._v("新增用户")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        { attrs: { data: _vm.tableData, border: "", stripe: "" } },
        [
          _c("el-table-column", {
            attrs: { label: "头像", "min-width": "50" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { style: { textAlign: "center" } },
                      [
                        _c("CustomPic", {
                          attrs: { "pic-src": scope.row.headerImg },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "uuid", "min-width": "250", prop: "uuid" },
          }),
          _c("el-table-column", {
            attrs: { label: "用户名", "min-width": "150", prop: "userName" },
          }),
          _c("el-table-column", {
            attrs: { label: "昵称", "min-width": "150", prop: "nickName" },
          }),
          _c("el-table-column", {
            attrs: { label: "用户角色", "min-width": "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-cascader", {
                      attrs: {
                        options: _vm.authOptions,
                        "show-all-levels": false,
                        props: {
                          multiple: true,
                          checkStrictly: true,
                          label: "authorityName",
                          value: "authorityId",
                          disabled: "disabled",
                          emitPath: false,
                        },
                        filterable: "",
                        clearable: false,
                      },
                      on: {
                        "visible-change": function (flag) {
                          _vm.changeAuthority(scope.row, flag)
                        },
                        "remove-tag": function () {
                          _vm.changeAuthority(scope.row, false)
                        },
                      },
                      model: {
                        value: scope.row.authorityId,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "authorityId", $$v)
                        },
                        expression: "scope.row.authorityId",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", "min-width": "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-popover",
                      {
                        attrs: { placement: "top", width: "160" },
                        model: {
                          value: scope.row.visible,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "visible", $$v)
                          },
                          expression: "scope.row.visible",
                        },
                      },
                      [
                        _c("p", [_vm._v("确定要删除此用户吗")]),
                        _c(
                          "div",
                          {
                            staticStyle: { "text-align": "right", margin: "0" },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "text" },
                                on: {
                                  click: function ($event) {
                                    scope.row.visible = false
                                  },
                                },
                              },
                              [_vm._v("取消")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteUser(scope.row)
                                  },
                                },
                              },
                              [_vm._v("确定")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              slot: "reference",
                              type: "danger",
                              icon: "el-icon-delete",
                              size: "mini",
                            },
                            slot: "reference",
                          },
                          [_vm._v("删除")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("span", { staticStyle: { color: "red", "font-size": "12px" } }, [
        _vm._v("注：右上角头像下拉可切换角色"),
      ]),
      _c("el-pagination", {
        style: { float: "right", padding: "20px" },
        attrs: {
          "current-page": _vm.page,
          "page-size": _vm.pageSize,
          "page-sizes": [10, 30, 50, 100],
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.addUserDialog,
            "custom-class": "user-dialog",
            title: "新增用户",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addUserDialog = $event
            },
            close: _vm.closeAddUserDialog,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "userForm",
              attrs: { rules: _vm.rules, model: _vm.userInfo, inline: true },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "用户名",
                    "label-width": "80px",
                    prop: "username",
                  },
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.userInfo.username,
                      callback: function ($$v) {
                        _vm.$set(_vm.userInfo, "username", $$v)
                      },
                      expression: "userInfo.username",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "密码",
                    "label-width": "80px",
                    prop: "password",
                  },
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.userInfo.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.userInfo, "password", $$v)
                      },
                      expression: "userInfo.password",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "别名",
                    "label-width": "80px",
                    prop: "nickName",
                  },
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.userInfo.nickName,
                      callback: function ($$v) {
                        _vm.$set(_vm.userInfo, "nickName", $$v)
                      },
                      expression: "userInfo.nickName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.userInfo.isBindMerchant,
                      expression: "userInfo.isBindMerchant",
                    },
                  ],
                  attrs: {
                    label: "商户名称",
                    "label-width": "80px",
                    prop: "merchantName",
                  },
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.userInfo.merchantName,
                      callback: function ($$v) {
                        _vm.$set(_vm.userInfo, "merchantName", $$v)
                      },
                      expression: "userInfo.merchantName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.userInfo.isBindMerchant,
                      expression: "userInfo.isBindMerchant",
                    },
                  ],
                  attrs: {
                    label: "支付通道",
                    "label-width": "80px",
                    prop: "payInChannelId",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "支付通道" },
                      on: { change: _vm.editInChannelSelect },
                      model: {
                        value: _vm.editInChannel,
                        callback: function ($$v) {
                          _vm.editInChannel = $$v
                        },
                        expression: "editInChannel",
                      },
                    },
                    _vm._l(_vm.channelList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.userInfo.isBindMerchant,
                      expression: "userInfo.isBindMerchant",
                    },
                  ],
                  attrs: {
                    label: "支付通道 ID",
                    "label-width": "100px",
                    prop: "PayInChannelItemId",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: _vm.editInChannelDisabled },
                      model: {
                        value: _vm.userInfo.PayInChannelItemId,
                        callback: function ($$v) {
                          _vm.$set(_vm.userInfo, "PayInChannelItemId", $$v)
                        },
                        expression: "userInfo.PayInChannelItemId",
                      },
                    },
                    _vm._l(_vm.editInChannelIdList, function (item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.userInfo.isBindMerchant,
                      expression: "userInfo.isBindMerchant",
                    },
                  ],
                  attrs: {
                    label: "提现通道",
                    "label-width": "80px",
                    prop: "PayOutChannelId",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "提现通道" },
                      on: { change: _vm.editOutChannelSelect },
                      model: {
                        value: _vm.editOutChannel,
                        callback: function ($$v) {
                          _vm.editOutChannel = $$v
                        },
                        expression: "editOutChannel",
                      },
                    },
                    _vm._l(_vm.channelList, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.userInfo.isBindMerchant,
                      expression: "userInfo.isBindMerchant",
                    },
                  ],
                  attrs: {
                    label: "提现通道 ID",
                    "label-width": "100px",
                    prop: "PayOutChannelItemId",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: _vm.editOutChannelDisabled },
                      model: {
                        value: _vm.userInfo.PayOutChannelItemId,
                        callback: function ($$v) {
                          _vm.$set(_vm.userInfo, "PayOutChannelItemId", $$v)
                        },
                        expression: "userInfo.PayOutChannelItemId",
                      },
                    },
                    _vm._l(_vm.editOutChannelIdList, function (item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "用户角色",
                    "label-width": "80px",
                    prop: "authorityId",
                  },
                },
                [
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.authOptions,
                      "show-all-levels": false,
                      props: {
                        multiple: true,
                        checkStrictly: true,
                        label: "authorityName",
                        value: "authorityId",
                        disabled: "disabled",
                        emitPath: false,
                      },
                      filterable: "",
                      clearable: false,
                    },
                    model: {
                      value: _vm.userInfo.authorityIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.userInfo, "authorityIds", $$v)
                      },
                      expression: "userInfo.authorityIds",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "是否为商户",
                    "label-width": "100px",
                    prop: "IsBindMerchant",
                  },
                },
                [
                  _c("el-switch", {
                    on: { change: _vm.isMerchant },
                    model: {
                      value: _vm.userInfo.isBindMerchant,
                      callback: function ($$v) {
                        _vm.$set(_vm.userInfo, "isBindMerchant", $$v)
                      },
                      expression: "userInfo.isBindMerchant",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.addUserDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.enterAddUserDialog },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("ChooseImg", {
        ref: "chooseImg",
        attrs: { target: _vm.userInfo, "target-key": "headerImg" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }